// we don't show gap cursor for those nodes
var IGNORED_NODES = ['paragraph', 'bulletList', 'orderedList', 'listItem', 'taskItem', 'decisionItem', 'heading', 'blockquote', 'layoutColumn', 'caption', 'media', 'extensionFrame'];
export var isIgnored = function isIgnored(node) {
  return !!node && IGNORED_NODES.indexOf(node.type.name) !== -1;
};